import { Components, Theme } from '@mui/material';

import { PrimaryColors } from '../constants';

export const formControlStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    transition: 'border-color 0.2s ease-in-out',

    '&.Mui-focused': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: PrimaryColors.diamond,
      },
      '.MuiSelect-outlined': {
        borderColor: PrimaryColors.diamond,
      },
    },
    '&.Mui-error': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: PrimaryColors.radical,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: PrimaryColors.carbon,
      },
    },
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: PrimaryColors.radical,
    marginLeft: 0,
  },

  '& .MuiFormHelperText-root:not(.Mui-error)': {
    textAlign: 'end',
    marginRight: 0,
  },
  '& .MuiInputLabel-root': {
    '&.Mui-filled, &.MuiFormLabel-filled': {
      transform: 'translate(14px, -9px) scale(0.75)',
    },
  },
};

export const MuiFormControl: Components<Theme>['MuiFormControl'] = {
  styleOverrides: {
    root: formControlStyles,
  },
};
